import React, { useState, useEffect } from 'react';
import './CreatureCompare.css';

function CreatureCompare({ creatureIds, onClose, apiUrl }) {
  const [creatures, setCreatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCreatures();
  }, [creatureIds]);

  const fetchCreatures = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/creatures/compare`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: creatureIds })
      });

      if (response.ok) {
        const data = await response.json();
        setCreatures(data.creatures);
      }
    } catch (error) {
      console.error('Failed to fetch creatures for comparison:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content comparison-modal" onClick={e => e.stopPropagation()}>
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading comparison...</p>
          </div>
        </div>
      </div>
    );
  }

  const statRows = [
    { label: 'Dungeon', key: 'dungeon' },
    { label: 'Slots', key: 'slots' },
    { label: 'Taming Required', key: 'taming' },
    { label: 'Class', key: 'class' },
    { label: 'Combat Type', key: 'combat' },
    { label: 'Hits', key: 'hits', highlight: true },
    { label: 'Min Damage', key: 'min_dmg', highlight: true },
    { label: 'Max Damage', key: 'max_dmg', highlight: true },
    { label: 'Wrestling', key: 'wrestling', highlight: true },
    { label: 'Armor', key: 'armor', highlight: true },
    { label: 'Magic Resist', key: 'magic_rst', highlight: true },
    { label: 'Poison Resist', key: 'poison_rst', highlight: true },
    { label: 'Special Resist', key: 'special_rst', highlight: true },
    { label: 'Poison', key: 'poison' },
    { label: 'Poisoning', key: 'poisoning' },
    { label: 'Stealth', key: 'stealth' },
    { label: 'Underdog Scalar', key: 'underdog_scalar' },
    { label: 'Cooldown Ability', key: 'cooldown_ability' },
    { label: 'Passive Ability', key: 'passive_ability' },
    { label: 'Innate Ability', key: 'innate_ability' }
  ];

  const findBestValue = (key) => {
    if (!statRows.find(r => r.key === key)?.highlight) return null;

    const values = creatures.map(c => c[key]).filter(v => v !== null && v !== undefined);
    if (values.length === 0) return null;

    return Math.max(...values);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content comparison-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Creature Comparison</h2>
          <button className="btn-close" onClick={onClose}>&times;</button>
        </div>

        <div className="comparison-table-container">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="stat-label">Attribute</th>
                {creatures.map(creature => (
                  <th key={creature.id} className="creature-header">
                    <div className="creature-name">{creature.name}</div>
                    <span className={`class-badge ${creature.class?.toLowerCase()}`}>
                      {creature.class}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {statRows.map(row => {
                const bestValue = findBestValue(row.key);
                return (
                  <tr key={row.key}>
                    <td className="stat-label">{row.label}</td>
                    {creatures.map(creature => {
                      const value = creature[row.key];
                      const isBest = row.highlight && value === bestValue && bestValue !== null;

                      return (
                        <td key={creature.id} className={isBest ? 'best-value' : ''}>
                          {value ?? '-'}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default CreatureCompare;
